var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEstonianFlagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.846,
    height: 37.848,
    viewBox: "0 0 37.846 37.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1722",
    x: 0,
    y: 0,
    width: 37.846,
    height: 37.848,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "estonian-flag-icon",
    transform: "translate(9 -3.15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, 3.15)",
    filter: "url(#Ellipse_1722)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1722-2",
    "data-name": "Ellipse 1722",
    cx: 9.923,
    cy: 9.924,
    rx: 9.923,
    ry: 9.924,
    transform: "translate(9 6)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "estonia",
    transform: "translate(-0.298 9.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33198",
    "data-name": "Path 33198",
    d: "M0,159.739a9.978,9.978,0,0,0,.622,3.478l9.378.435,9.378-.435a10.036,10.036,0,0,0,0-6.957L10,155.826l-9.378.435A9.979,9.979,0,0,0,0,159.739Z",
    transform: "translate(0 -149.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33199",
    "data-name": "Path 33199",
    d: "M25.3,0a10,10,0,0,0-9.378,6.522H34.679A10,10,0,0,0,25.3,0Z",
    transform: "translate(-15.301)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33200",
    "data-name": "Path 33200",
    d: "M34.679,345.043H15.923a10,10,0,0,0,18.756,0Z",
    transform: "translate(-15.301 -331.565)",
    fill: "#f0f0f0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstonianFlagIcon);
export default __webpack_public_path__ + "static/media/estonian-flag-icon.759e6b45770e09e311707bff7f2bd50f.svg";
export { ForwardRef as ReactComponent };